<template>
	<div class="result">
		<div class="content">			
		    <div class="card" v-for="(item,index) in res" :key="index">
		        <div class="card-header" id="onePiece_maxGoods">{{item.member2}}件</div>
		        <div class="card-content">
		            <div class="card-content-inner">
		                <h1>{{item.member1}}</h1>
		            </div>
		        </div>
		        <div class="card-footer">
		            <div class="leftdiv" id="perPiece_maxGoods_money">{{item.member3}}</div>
		            <div class="rightdiv" id="allPiece_maxGoods_money">{{item.member1 * item.member3}}</div>
		        </div>
		    </div>
		
		    <div class="content-block" v-on:click="previous()">
		        <div class="col-50"><a href="#" class="button button-big button-fill button-success confirm-title-ok-cancel">返回</a></div>
		    </div>
			
			<div class="content-block">
				<div class="card-missme"><a href="tel:13148403840">想我了吗？点击这里找我。</a></div>
			</div>
		</div>   
	</div>
</template>

<script>
	export default {
		name: 'result',
		data() {
			return {
				res:[]
			}	
		},
		created() {
			// 接收上个页面的计算结果
			var myquery = this.$route.query; 
			
			if (myquery.val1 * myquery.val3 != 0) {
			    this.res.push({
					member1: myquery.val1,
					member2: myquery.val2,
					member3: myquery.val3,
				});
			}
			
			if (myquery.val4 * myquery.val6 != 0) {
			    this.res.push({
					member1: myquery.val4,
					member2: myquery.val5,
					member3: myquery.val6,
				});
			}				
		},
		methods: {
			previous() {	
				this.$router.push({name:'home'});
				// $.confirm('Are you sure?',
				//   function () {
				// 	$.alert('You clicked Ok button');
				//   },
				//   function () {
				// 	$.alert('You clicked Cancel button');
				//   }
				// )  					
			}			
		}	
	}
</script>

<style scoped="scoped">
	.content {
	    padding-top: 10px;
	}
	
	.card {
	    background-color: #FF8A81;
	    color: white;
	}
	
	.card-content-inner {
	    padding: 0;
	}
	
	.card-content-inner h1 {
	    text-align: center;
	}
	
	.card-footer {
	    color: white;
	}
	
	.card-footer .leftdiv{
	    width: 50%;
	    float: left;
	    text-align: left;
	}
	
	.card-footer .rightdiv{
	    width: 50%;
	    float: right;
	    text-align: right;
	}
	
	.card-missme{
		text-align: center;
	}
</style>
